import React from 'react'
import psyduckError from '../../image/psyduckerror.png';


import { css } from '@emotion/css';

export default function LoadingError() {
    return (
        <div className={css`
        display:flex;
        align-items:center;
        flex-direction:column;
        padding: 40px 0px;
        `}>
            <div>Something went wrong!.... Connection error or page not found?</div>

            <img src={psyduckError} alt=""></img>
        </div>
    )
}
